import React, { useEffect, useMemo, useState, useRef } from "react";
import "./Blocks.scss";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';
import NewCardSkeleton from "../Skeleton/NewCardSkeleton/NewCardSkeleton";
import { useTranslation } from "react-i18next";
import ProductCard from "../ProductCard/ProductCard";
import ProductCardSmall from "../ProductCardSmall/ProductCardSmall";
import SmallCardSkeleton from "../Skeleton/SmallCardSkeleton/SmallCardSkeleton";
import request from "../../request";
import star from '../../assets/images/home/star.svg'
import fire from '../../assets/images/home/fire.svg'

function Blocks({ title, like, id, CATAGORYID, CATAGORYNAME, seemore, setRefreshAPI, refreshAPI, page, COUNT, desktopBanner, mobileBanner }) {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const [scrollOptions, setScrollOptions] = useState(window.innerWidth > 1100 ? 4 : window.innerWidth > 1024 ? 3 : window.innerWidth > 920 ? 3 : window.innerWidth > 812 ? 3 : window.innerWidth > 465 && 1)
  const isNewArrivalProduct = title === "New Arrival" ? true : false
  const isTrendingProduct = title === "Trending Products" ? true : false

  useEffect(() => {
    if (page === "searchSuggest") {
      setScrollOptions(window.innerWidth > 1366 ? 3 : window.innerWidth > 1100 ? 2 : window.innerWidth > 920 ? 2 : window.innerWidth > 812 ? 2 : window.innerWidth > 465 && 1)
    }
    else if (like?.length < 5) {
      setScrollOptions(window.innerWidth > 1366 ? 6 : window.innerWidth > 1100 ? 4 : window.innerWidth > 920 ? 3 : window.innerWidth > 812 ? 3 : window.innerWidth > 465 && 1)
    }
    else if (title != "Trending Products") {
      if (page === "searchSuggest") {
        setScrollOptions(window.innerWidth > 1366 ? 3 : window.innerWidth > 1100 ? 2 : window.innerWidth > 920 ? 2 : window.innerWidth > 812 ? 2 : window.innerWidth > 465 && 1)
      } else {
        setScrollOptions(window.innerWidth > 1366 ? 6 : window.innerWidth > 1100 ? 4 : window.innerWidth > 1024 ? 4 : window.innerWidth > 920 ? 3 : window.innerWidth > 812 ? 3 : window.innerWidth > 465 && 1)
      }
    }
    else if (title == "Trending Products" && like?.length > 5) {
      setScrollOptions(window.innerWidth > 1366 ? 6 : window.innerWidth > 1100 ? 4 : window.innerWidth > 1024 ? 3 : window.innerWidth > 920 ? 3 : window.innerWidth > 812 ? 3 : window.innerWidth > 465 && 1)
    }
    else if (title === "New Arrival" && like?.length > 5) {
      setScrollOptions(window.innerWidth > 1366 ? 6 : window.innerWidth > 1100 ? 4 : window.innerWidth > 1024 ? 3 : window.innerWidth > 920 ? 3 : window.innerWidth > 812 ? 3 : window.innerWidth > 465 && 1)
    }
  }, [title, like, window.innerWidth])
  const CustomPrevArrow = ({ onClick }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={onClick} className="slick-prev">
      <g clip-path="url(#clip0_2783_3813)">
        <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="#1C3454" fill-opacity="0.26" />
      </g>
      <defs>
        <clipPath id="clip0_2783_3813">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const CustomNextArrow = ({ onClick }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={onClick} className="slick-next">
      <g clip-path="url(#clip0_2783_10433)">
        <path d="M9.99997 6L8.58997 7.41L13.17 12L8.58997 16.59L9.99997 18L16 12L9.99997 6Z" fill="#192434" />
      </g>
      <defs>
        <clipPath id="clip0_2783_10433">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const settings = {
    dots: false,
    speed: 400,
    infinite: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,

    // --- BASE SETTINGS ---

    // Rows: 1 for Search Suggest, 2 for Special Deal and Remaining.
    rows: page === 'searchSuggest' ? 1 : 2,

    // Define the number of columns per row (slidesPerRow).
    slidesPerRow:
      page === 'searchSuggest' ? 1 :             // Search Suggest: Not needed, but default to 1
        title === 'Special Deal' ? 5 :             // Special Deal: Multi-row, 5 columns wide
          4,                                         // Remaining: Multi-row, 4 columns wide

    // SlidesToShow: CRITICAL. Must be 1 for ANY multi-row setting (rows: 2).
    slidesToShow:
      page === 'searchSuggest' ? 3 :             // Search Suggest: Single Row, show 3 products
        1,                                         // Special Deal & Remaining: Multi-Row MUST be 1

    // SlidesToScroll: Must match slidesToShow for single-row, and be 1 for multi-row.
    slidesToScroll:
      page === 'searchSuggest' ? 3 :
        1, // Scroll one full grid page (10 items for Special Deal, 8 for Remaining)

    // --- RESPONSIVE SETTINGS: Mobile View Correction ---
    responsive: [
      {            // Large Laptops / Desktops
        breakpoint: 1100,
        settings: {
          rows: page === 'searchSuggest' ? 1 : 2,
          slidesPerRow: page === 'searchSuggest' ? 1 : (title === 'Special Deal' ? 5 : 4),
          slidesToShow: page === 'searchSuggest' ? 3 : 1,
          slidesToScroll: page === 'searchSuggest' ? 3 : 1,
          infinite: true,
        }
      },
      {
        // Medium Laptops / Large Tablets (Horizontal) - Show 3-4 items/columns
        breakpoint: 1024,
        settings: {
          rows: page === 'searchSuggest' ? 1 : 2,
          // Reduced columns for multi-row cases
          slidesPerRow: page === 'searchSuggest' ? 1 : (title === 'Special Deal' ? 4 : 3),
          slidesToShow: page === 'searchSuggest' ? 3 : 1, // Keep 1 for multi-row
          slidesToScroll: page === 'searchSuggest' ? 3 : 1,
          infinite: true,
        }
      },
      {
        // Small Laptops / Tablets (Vertical) - Show 2-3 items/columns
        breakpoint: 912,
        settings: {
          // Moving all cases to a single row is often safer at this size
          rows: 1,
          slidesPerRow: 1, // Defaulting to 1 when rows=1
          slidesToShow: title === 'Special Deal' ? 3 : (page === 'searchSuggest' ? 2 : 3),
          slidesToScroll: title === 'Special Deal' ? 3 : (page === 'searchSuggest' ? 2 : 3),
          infinite: true,
        }
      },
      {
        // Smaller Tablets / Large Phones (Landscape) - Show 2 items
        breakpoint: 812,
        settings: {
          rows: 1,
          slidesPerRow: 1,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      // Mobile View (580px and below) - All cases show 1 row, 2 products.
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          rows: 1, // Force to single row for mobile
          slidesPerRow: 1,
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          rows: 1,
          slidesPerRow: 1,
        }
      },
    ]
  };

  // const settings = {
  //     dots: false,
  //     speed: 400,
  //     // rows: 2,
  //     slidesToShow: title === 'Special Deal' ? 5 : page === 'searchSuggest' ? 3 : 4,
  //     slidesToScroll: title === 'Special Deal' ? 5 : page === 'searchSuggest' ? 3 : 4,
  //     infinite: true,
  //     rows: page === 'searchSuggest' ? 1 : 2,
  //     prevArrow: <CustomPrevArrow />,
  //     nextArrow: <CustomNextArrow />,
  //     responsive: [
  //       {
  //         breakpoint: 1100,
  //         settings: {
  //           slidesToShow: title === 'Special Deal' ? 5 : page === 'searchSuggest' ? 3 : 4,
  //           slidesToScroll: title === 'Special Deal' ? 5 : page === 'searchSuggest' ? 3 : 4,
  //           infinite: true,
  //           rows: page === 'searchSuggest' ? 1 : 2,
  //         }
  //       },
  //       {
  //         breakpoint: 1024,
  //         settings: {
  //           slidesToShow: page === 'searchSuggest' ? 1 : 3,
  //           slidesToScroll: page === 'searchSuggest' ? 2 : 3,
  //           infinite: true,
  //           rows: page === 'searchSuggest' ? 1 : 2,
  //         }
  //       },
  //       {
  //         breakpoint: 912,
  //         settings: {
  //           slidesToShow: page === 'searchSuggest' ? 2 : (isTrendingProduct ? 6 : 4),
  //           slidesToScroll: page === 'searchSuggest' ? 2 : (isTrendingProduct ? 6 : 4),
  //           infinite: true,
  //           rows: page === 'searchSuggest' ? 1 : 2,
  //         }
  //       },
  //       {
  //         breakpoint: 812,
  //         settings: {
  //           slidesToShow: page === 'searchSuggest' ? 2 : (isTrendingProduct ? 4 : 2),
  //           slidesToScroll: page === 'searchSuggest' ? 2 : (isTrendingProduct ? 4 : 2),
  //           infinite: true,
  //           rows: page === 'searchSuggest' ? 1 : 2,
  //         }
  //       },
  //       {
  //         breakpoint: 580,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //           infinite: true,
  //           rows: 1,
  //         }
  //       },
  //       {
  //         breakpoint: 420,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //           infinite: true,
  //           rows: 1,
  //         }
  //       },
  //     ]
  //   };
  // PDP page Similar product slider setting
  //   const pdpPageSettings = {
  //   dots: false,
  //   infinite: like?.length > 3 ? true : false, // Ensure it only loops if there are more than 3 items
  //   speed: 500,
  //   slidesToScroll: 3, // Always scroll 3 slides at a time
  //   slidesToShow: 3,   // Always show 3 slides
  //   prevArrow: <CustomPrevArrow />,
  //   nextArrow: <CustomNextArrow />,
  //   responsive: [
  //     {
  //       breakpoint: 1100,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       }
  //     },
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       }
  //     },
  //     {
  //       breakpoint: 912,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       }
  //     },
  //     {
  //       breakpoint: 812,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       }
  //     },
  //     {
  //       breakpoint: 580,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       }
  //     },
  //     {
  //       breakpoint: 420,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //       }
  //     },
  //   ]
  // };


  const pdpPageSettings = {
    dots: false,
    // Use Math.min(3, like?.length) to determine the scroll amount, but keeping it fixed at 3 is cleaner
    // like?.length > 3 ? true : false, is a better check for infinite
    infinite: like?.length > 3,
    speed: 500,

    // CORRECTION: Use slidesToShow and omit slidesPerRow for a single-row carousel 💥
    slidesToShow: 3,     // Show 3 slides across the screen
    slidesToScroll: 3,   // Scroll 3 slides at a time (full page scroll)

    // Omit 'slidesPerRow' and 'rows' for single-row display
    // slidesPerRow: 3, 
    // rows: 1, 

    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        // Large Desktops (1100px and up) - No change, handled by base settings
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: like?.length > 3,
        }
      },
      {
        // Tablets (1024px to ~912px) - Still show 3
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: like?.length > 3,
        }
      },
      {
        // Smaller Tablets (912px to 812px) - Show 2-3 slides depending on preference
        breakpoint: 912,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: like?.length > 2, // Check if enough items exist for the new scroll size
        }
      },
      {
        // Mobile Landscape/Small Tablets (812px to 580px) - Show 2
        breakpoint: 812,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: like?.length > 2,
        }
      },
      {
        // Mobile Portrait (580px to 420px) - Show 1 or 2 small slides
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: like?.length > 1,
        }
      },
      {
        // Very Small Phones (Under 420px) - Show 1
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: like?.length > 1,
        }
      },
    ]
  };


  const replacements = {
    "KG": t('KG'),
    "PC": t('PC'),
    "PK": t('PK'),
    "BG": t("BG"),
    "BK": t("BK"),
    "BT": t("BT"),
    "BX": t("BX"),
    "CA": t("CA"),
    "CP": t("CP"),
    "CT": t("CT"),
    "DR": t("DR"),
    "DZ": t("DZ"),
    "GL": t("GL"),
    "GM": t("GM"),
    "JR": t("JR"),
    "LT": t("LT"),
    "ML": t("ML"),
    "OZ": t("OZ"),
    "PA": t("PA"),
    "SC": t("SC"),
    "SH": t("SH"),
    "TI": t("TI"),
    "TR": t("TR"),
    "TU": t("TU"),
    "TY": t("TY"),
  };

  const updatedData = (item => {
    let updatedItem = item;
    Object.keys(replacements).forEach(key => {
      updatedItem = updatedItem.replace(key, replacements[key]);
    });

    return updatedItem;
  });

  const recommendedCarousel = useMemo(() => {
    if (like?.length) {
      return like.map((data, i) => (
        <LazyLoad key={i}>
          <ProductCardSmall
            data={data}
            setRefreshAPI={setRefreshAPI}
            refreshAPI={refreshAPI}
            title={title}
            page={page}
          />
        </LazyLoad>
      ));
    }

    // Skeleton loading logic
    if (title === "Trending Products") {
      return [...Array(6)].map((_, index) => <SmallCardSkeleton key={index} />);
    }
    return [...Array(7)].map((_, index) => <NewCardSkeleton key={index} />);
  }, [like, title, setRefreshAPI, refreshAPI]);

  const recommendedCarouselMobile = useMemo(() => {
    return like?.length ? like?.map((data, i) => (
      <ProductCardSmall
        key={i}
        data={data}
        setRefreshAPI={setRefreshAPI}
        refreshAPI={refreshAPI}
        devicetype={window.innerWidth > 912 ? "desktop" : "mobile"}
      />
    )) : ""
  }, [like, window.innerWidth]);


  let campaignId;
  const trimmedTitle = title?.trim();
  if (trimmedTitle === "Trending Products") {
    campaignId = 12;
  } else if (trimmedTitle === "New Product Arrival" || trimmedTitle === "New Arrival" || trimmedTitle === "New Arrivals" || trimmedTitle === "Recommended For You") {
    campaignId = 13;
    // campaignId = 15;
  } else if (trimmedTitle === "Special Deal") {
    campaignId = 21;
  } else if (trimmedTitle === "7 Days Low Price Deal") {
    campaignId = 12;
  } else if (trimmedTitle === "Foodie Favourites Sale") {
    campaignId = 17;
  } else if (trimmedTitle === "Hot & Fresh Just For You") {
    campaignId = 14;
  } else if (trimmedTitle === "Recommended Products") {
    campaignId = 15;
  } else if (trimmedTitle === "Hot and Fresh Just for You" || trimmedTitle === "Premium Flavors, Accessible to All" || trimmedTitle === "End of Season Sale") {
    campaignId = 12;
  }

  const generateLink = () => {
    const isWideScreen = window.innerWidth > 912;

    if (["Fresh & Healthy Greens"].includes(trimmedTitle)) {
      return isWideScreen
        ? `/catalog/Vegetables & Fruits/${CATAGORYID}`
        : `/MCatalog/${id}`;
    }

    if (["Trending Products", "Special Deal", "7 Days Low Price Deal", "Recommended For You", "Recommended Products", "New Product Arrival", "New Arrivals", "Hot and Fresh Just for You", "Premium Flavors, Accessible to All", "End of Season Sale", "Hot & Fresh Just For You", "Foodie Favourites Sale", "สินค้าแนะนำสำหรับคุณ"].includes(trimmedTitle)) {
      // if (["Trending Products", "New Arrival", "Recommended For You", "สินค้าแนะนำสำหรับคุณ"].includes(title)) {
      return isWideScreen
        ? `/campaign/household/${campaignId}/${request.householdCategoryId.STOREID}/${request.householdCategoryId.categoryId} `
        : `/campaign/household/${campaignId}/${request.householdCategoryId.STOREID}/${request.householdCategoryId.categoryId} `;
    } else {
      return isWideScreen
        ? `/catalog/${title}/${CATAGORYID}/${CATAGORYNAME}/${id}`
        : `/MCatalog/${id}`;
    }
  };

  return (
    <div className={`blocks ${title === "New Arrival" || title === "Trending Products" ? 'no-background' : ''}`}>
      <div className="blocks__header">
        <div className="header-title-wrapper">
          <div className={title === "Special Deal" ? "fire-icon" : "star-icon"}>{title === "Special Deal" ? <img src={fire} alt="" /> : <img src={star} alt="" />}</div>
          <div className="block_title">{title ? t(title) : ""}</div>
        </div>
        {/* {(seemore || (seemore === undefined && CATAGORYID)) && window.innerWidth > 912 && (
        {(seemore || (seemore === undefined && CATAGORYID)) && window.innerWidth > 912 && (
          <div className="slider-arrows">
            <CustomPrevArrow onClick={() => sliderRef.current?.slickPrev()} />
            <CustomNextArrow onClick={() => sliderRef.current?.slickNext()} />
          </div>
        )} */}
        {seemore || seemore == undefined && CATAGORYID ?
          <Link to={generateLink()}
            onClick={() => localStorage.setItem("redirectAfterLogin", generateLink())}
          >
            {t("More")}

            {/* {t(">")} */}
            {/* Hide SVG icon for mobile */}
            {window.innerWidth > 912 && (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_1865_13276)">
                  <path d="M9.99997 6L8.58997 7.41L13.17 12L8.58997 16.59L9.99997 18L16 12L9.99997 6Z" fill="#1B2B41" fill-opacity="0.69" />
                </g>
                <defs>
                  <clipPath id="clip0_1865_13276">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            )}
          </Link> : ""}
      </div>

      {
        window.innerWidth > 912 && (
          page === "pdpPage" ? (
            <div className="similar_product_pdp_web">
              <Slider {...(page === "pdpPage" ? pdpPageSettings : settings)}>
                {recommendedCarousel}
              </Slider>
            </div>
          ) : (
            <div className="home_web">
              {/* The image paths below are placeholders. Please update them with the correct paths to your assets. */}
              {(page !== "searchSuggest" && desktopBanner) &&
                <div className="title_block">
                  {/* <img src={desktopBanner} alt={title} /> */}
                  <img src={`${request?.CDN_PRODUCT_CAMPAIGN}${desktopBanner}`} alt={title} />
                </div>
              }
              <Slider ref={sliderRef} {...(settings)}>
                {recommendedCarousel}
              </Slider>
            </div>
          )
        )
      }

      {
        window.innerWidth <= 912 && (
          page !== "home" ?
            <>
              {(page !== "searchSuggest" && mobileBanner) &&
                <div className="title_block">
                  {/* <img src={mobileBanner} alt={title} /> */}
                  <img src={`${request?.CDN_PRODUCT_CAMPAIGN}${mobileBanner}`} alt={title} />
                </div>
              }
              <Slider {...settings}>{recommendedCarouselMobile}</Slider>
            </>
            :
            <div className="MOBILE__BLOCKS">
              {(page !== "searchSuggest" && mobileBanner) &&
                <div className="title_block">
                  <img src={`${request?.CDN_PRODUCT_CAMPAIGN}${mobileBanner}`} alt={title} />
                </div>
              }
              <Slider {...settings}>{recommendedCarouselMobile}</Slider>

              {/* {like?.map((data, i) => (
                <ProductCard
                  key={i}
                  data={data}
                  setRefreshAPI={setRefreshAPI}
                  refreshAPI={refreshAPI}
                  title={title}
                  devicetype={window.innerWidth > 912 ? "desktop" : "mobile"}
                />
              ))} */}
            </div>
        )
      }
    </div >
  );

}

export default Blocks;
